import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Blocks, Clock3, Cog, ExternalLink, Gauge, LogOut, Moon } from 'lucide-react';
import { api } from '../api.js';
import { useSession } from '../session.js';
import { applyTheme, currentTheme } from '../theme.js';
import { Screen, Rows, Row, Toggle } from '../ui/kit.js';
import { reporter } from '../pwa/report.js';

export function More() {
  const navigate = useNavigate();
  const { refresh } = useSession();
  const [dark, setDark] = useState(currentTheme() === 'dark');
  const flipTheme = (v: boolean) => {
    setDark(v);
    applyTheme(v ? 'dark' : 'light');
    void api.put('/api/settings', { theme: v ? 'dark' : 'light' }).catch(reporter('the theme'));
  };
  return (
    <Screen title="More">
      <Rows>
        <Row
          title="Blocks"
          sub="The prompt pieces every job can carry"
          end={<Blocks size={17} />}
          onTap={() => navigate('/blocks')}
        />
        <Row
          title="Notifications"
          sub="The tray, and what reaches the lock screen"
          end={<Bell size={17} />}
          onTap={() => navigate('/notifications')}
        />
        <Row
          title="Capacity"
          sub="Slots · accounts and models · the merge queue"
          end={<Gauge size={17} />}
          onTap={() => navigate('/capacity')}
        />
        <Row
          title="History & stats"
          sub="Job outcomes · CI pass rate · time to green"
          end={<Clock3 size={17} />}
          onTap={() => navigate('/history')}
        />
        <Row
          title="Settings"
          sub="Claude accounts · engine · spend · box health"
          end={<Cog size={17} />}
          onTap={() => navigate('/settings')}
        />
        <Row
          title="Dark theme"
          sub="The night control room, if you want it back"
          end={
            <>
              <Moon size={17} />
              <Toggle checked={dark} onChange={flipTheme} label="Dark theme" />
            </>
          }
        />
        <Row
          title="Meridian Console"
          sub="Hospitals, releases, the ceremony"
          end={<ExternalLink size={17} />}
          onTap={() => window.open('https://console.meridian.dhs.africa', '_blank', 'noopener,noreferrer')}
        />
        <Row
          title="Sign out"
          sub="This phone keeps its passkey"
          end={<LogOut size={17} />}
          onTap={() => void api.post('/api/auth/logout').then(refresh).catch(reporter('signing out'))}
        />
      </Rows>
      <p className="ops-hint" style={{ textAlign: 'center', marginTop: 18 }}>
        Meridian Ops · the change pipeline in your pocket and on your desk.
      </p>
    </Screen>
  );
}
